import { Dispatch, SetStateAction, createContext } from 'react'

interface IContextProps {
    setTransfersInputs: Dispatch<SetStateAction<TransfersInputs>>
    transfersInputs: TransfersInputs
    loader: {
        ACQUIRING_TRANSFERS_DOWNLOAD: boolean | null
    }
}

export const Context = createContext({} as IContextProps)
